import PropTypes from 'prop-types';
import React from 'react';
import { Generic } from 'app/components/shared/GenericMessage';

import './ToastMessage.scss';

const ToastMessage = ({ className = '', ...props }) => {
  const classNames = `cp-toast-message ${className}`;

  return (
    // Static data-key: GlobalMessaging renders at most one toast, so the key is
    // page-unique — the stable hook QA e2e asserts outcomes (success/error toasts) on.
    <div className={classNames} data-key="global-toast">
      <Generic {...props} />
    </div>
  );
};

ToastMessage.propTypes = {
  clearMessages: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default ToastMessage;
